// Multi-Purpose Bot Service
// Handles all bot interactions via Cloudflare Worker

const BOT_WORKER_URL = import.meta.env.VITE_BOT_WORKER_URL || 'https://mavililer-bot.abdulkadirocal.workers.dev'

export interface BotResponse {
    success: boolean
    action: string
    results: any[]
    successfulRelay: string
}

// Feature 1: Announce New Topic
export async function announceNewTopic(title: string): Promise<BotResponse> {
    const response = await fetch(BOT_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'announce', title })
    })

    if (!response.ok) {
        throw new Error('Failed to announce topic')
    }

    return await response.json()
}

// Feature 2: Publish Daily Digest
export async function publishDailyDigest(topics: string[]): Promise<BotResponse> {
    const response = await fetch(BOT_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'digest', topics })
    })

    if (!response.ok) {
        throw new Error('Failed to publish digest')
    }

    return await response.json()
}

// Feature 3: Update Bot Profile
export async function updateBotProfile(): Promise<BotResponse> {
    const response = await fetch(BOT_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'profile' })
    })

    if (!response.ok) {
        throw new Error('Failed to update profile')
    }

    return await response.json()
}

// Feature 4: Moderate Content
export async function moderateContent(eventId: string, reason: string): Promise<BotResponse> {
    const response = await fetch(BOT_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'moderate', eventId, reason })
    })

    if (!response.ok) {
        throw new Error('Failed to moderate content')
    }

    return await response.json()
}

// Feature 5: Fetch Ekşi Sözlük Agenda
export async function fetchEksiAgenda(force: boolean = false): Promise<string[]> {
    const response = await fetch(BOT_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'agenda', force })
    })

    if (!response.ok) {
        throw new Error('Failed to fetch agenda')
    }

    const data = await response.json() as BotResponse & { results: string[] }
    return data.results || []
}

// Feature 6: Health Check
export async function checkBotHealth(): Promise<boolean> {
    try {
        const response = await fetch(BOT_WORKER_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'ping' })
        })
        return response.ok
    } catch (e) {
        return false
    }
}
